// Generated by ReScript, PLEASE EDIT WITH CARE

import BoxModuleCss from "./box.module.css";
import LinkModuleCss from "./link.module.css";
import ListModuleCss from "./list.module.css";
import PageModuleCss from "./page.module.css";
import RadioModuleCss from "./radio.module.css";
import StackModuleCss from "./stack.module.css";
import TableModuleCss from "./table.module.css";
import ButtonModuleCss from "./button.module.css";
import UtilityModuleCss from "./utility.module.css";
import CheckboxModuleCss from "./checkbox.module.css";
import FieldsetModuleCss from "./fieldset.module.css";
import MessageBarModuleCss from "./messageBar.module.css";
import DescriptionListModuleCss from "./descriptionList.module.css";

let box = BoxModuleCss;

let button = ButtonModuleCss;

let checkbox = CheckboxModuleCss;

let descriptionList = DescriptionListModuleCss;

let fieldset = FieldsetModuleCss;

let link = LinkModuleCss;

let list = ListModuleCss;

let messageBar = MessageBarModuleCss;

let page = PageModuleCss;

let radio = RadioModuleCss;

let stack = StackModuleCss;

let table = TableModuleCss;

let utility = UtilityModuleCss;

export {
  box,
  button,
  checkbox,
  descriptionList,
  fieldset,
  link,
  list,
  messageBar,
  page,
  radio,
  stack,
  table,
  utility,
}
/* box Not a pure module */
